import { render, staticRenderFns } from "./RegulationForm.vue?vue&type=template&id=8f17bfae&scoped=true&"
import script from "./RegulationForm.vue?vue&type=script&lang=js&"
export * from "./RegulationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegulationForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegulationForm.vue?vue&type=style&index=1&id=8f17bfae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f17bfae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VForm,VRow})
